import { Api } from "@/core/services/api.service";
import { QueryUrlBuilderService } from "@/core/services/queryUrlBuilder.service";
import { UserAdapter } from "@/core/models/user";

const fetchUsersList = async (page, itemsPerPage, filters = {}) => {
  const urlBuilder = new QueryUrlBuilderService("users").withPagination(page, itemsPerPage);

  urlBuilder.withSort(filters?.sort, filters?.order);
  delete filters?.sort;
  delete filters?.order;

  urlBuilder.withFilters(filters);

  const url = urlBuilder.get();

  const response = await Api.new().get(url, { headers: { Accept: "application/ld+json" } });

  return {
    totalItems: response.data["hydra:totalItems"],
    users: response.data["hydra:member"],
  };
};

const fetchUserPermissions = async (userId) => {
  return (await Api.new().get(`/users/${userId}/permissions`)).data;
};

const fetchUserById = async (userId) => {
  const response = await Api.new().get(`users/${userId}`);

  return UserAdapter.adapt(response.data);
};

const fetchAssignableUserTypes = async () => {
  return (await Api.new().get(`/assignable-user-types`)).data;
};

const createUser = async (newUserData) => {
  const response = await Api.new().post("users", newUserData);

  return UserAdapter.adapt(response.data);
};

const updateUser = async (userId, updatedUserData) => {
  const response = await Api.new().patch(`users/${userId}`, updatedUserData, {
    headers: { "Content-Type": "application/merge-patch+json" },
  });

  return UserAdapter.adapt(response.data);
};

export default {
  fetchUsersList,
  fetchUserPermissions,
  fetchUserById,
  fetchAssignableUserTypes,
  createUser,
  updateUser,
};
